var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('Header'),_c('main',{staticClass:"site-main",class:{ 'site-main-full': _vm.fullMain }},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }